module.exports = __webpack_public_path__ + "01_short_brown.31988f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_short_brown.png
// module id = 4y9E
// module chunks = 0